import { createGlobalStyle } from "styled-components";
import normalize from "styled-normalize";

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    letter-spacing: -0.025rem;
  }

  html, body {
    font-size: 10px;
    font-family: 'Prentedard', 'NanumSquareRound', sans-serif;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  p {
    margin: 0;
  }
`;
